import React from "react";
import * as S from "./InclusionList.styles";

interface iInclusion {
  data: Array<string>;
}

const InclusionListUI: React.FC<iInclusion> = ({ data = [] }) => {
  return (
    <S.InclusionLists>
      {data.map((item, index) => (
        <li key={`InclusionList${index}`}>{item}</li>
      ))}
    </S.InclusionLists>
  );
};

export default React.memo(InclusionListUI);
